var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KTextbox',{attrs:{"label":"Enter password","type":"password","value":"My password"}})
}
var staticRenderFns = []

export { render, staticRenderFns }